export enum EventPrechecks {
  LOBBY = "lobby",
  MIC_CAM_CHECK = "mic-cam-check",
  ONBOARDING = "onboarding",
  TRIAL_EXPIRED = "trial-expired",
}

export enum PrecheckStatus {
  FAIL = "FAIL",
  PASS = "PASSED",
  PENDING = "PENDING",
}
